import styled from '@emotion/styled';

export const UserMenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 10px;
  min-width: 170px;

  border: 1px solid ${({ theme }): string => theme.WHITE};
  border-radius: 6px;
  color: ${({ theme }): string => theme.WHITE};

  font-style: normal;
  font-weight: 500;
  font-size: 12px;

  cursor: pointer;
`;

export const Vendor = styled.p`
  font-weight: normal;
  color: ${({ theme }): string => theme.WHITE};
  padding-top: 4px;
`;
